import { IRolesState } from './store';
import { RolesActions, RolesActionTypes } from './actionTypes';

const initialState: IRolesState = ({

});

export function rolesReducer (
  state = initialState,
  action: RolesActions
): IRolesState {
  switch (action.type) {
    case RolesActionTypes.FETCH_ROLES_INFO_SUCCESS:
      return {
        ...state,
        rolesInfo: action.rolesInfo,
        status: 200
      };
    case RolesActionTypes.FETCH_ROLES_SUCCESS:
      return {
        ...state,
        roles: action.roles,
        status: 200
      };
    case RolesActionTypes.POST_ROLE_SUCCESS:
      return {
        ...state,
        roles: [...(state.roles || []), action.role],
        status: action.status
      };
    case RolesActionTypes.DELETE_ROLE_SUCCESS:
      return {
        ...state,
        roles: [...(state.roles || [])].filter(r1 => action.role.name !== r1.name),
        status: 200
      };
    case RolesActionTypes.PUT_ROLE_SUCCESS:
      return {
        ...state,
        roles: [...(state.roles || [])].map(r1 => action.role.name === r1.name ? action.role : r1),
        status: 200
      };
    case RolesActionTypes.FETCH_ROLES_INFO_ERROR:
    case RolesActionTypes.FETCH_ROLES_ERROR:
    case RolesActionTypes.POST_ROLE_ERROR:
    case RolesActionTypes.DELETE_ROLE_ERROR:
    case RolesActionTypes.PUT_ROLE_ERROR:
      return {
        ...state,
        status: action.status,
      };
    case RolesActionTypes.CLEAR_ERROR:
      return {
        ...state,
        status: undefined
      };
  }
  return state;
}